var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.32A1.5 1.5 0 0 0 10.7.25C9.75 0 6 0 6 0S2.25 0 1.31.25A1.5 1.5 0 0 0 .25 1.32C0 2.26 0 4.22 0 4.22S0 6.2.25 7.15c.14.52.55.93 1.06 1.06.94.26 4.69.26 4.69.26s3.75 0 4.69-.26a1.5 1.5 0 0 0 1.06-1.06C12 6.2 12 4.23 12 4.23s0-1.97-.25-2.9Zm-6.98 4.7V2.44l3.14 1.78L4.77 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubesmall);
export default __webpack_public_path__ + "static/media/youtube.small.e66ac8979c1b4a49bdf0981ae9890d05.svg";
export { ForwardRef as ReactComponent };